<template>
  <div class="status" :class="{
    'status-span-center': isOff
  }">

    <span class="status-span">
      {{ bonusType }}
    </span>

    <span class="status-span" v-if="!isOff"
      :class="{
        'green': !isDiscount,
        'danger':isDiscount
      }"
    >
      {{ bonusPercentage }}
    </span>

  </div>
</template>

<script>

import get from 'lodash/get'

export default {
  computed: {

    bonusType () {
      switch (this.params.data.bonus_type) {

      case this.$constants.BONUS_TYPES.OFF:
        return 'Off'

      case this.$constants.BONUS_TYPES.DISCOUNT:
        return 'Discount'

      case this.$constants.BONUS_TYPES.BONUS:
        return 'Bonus'

      case this.$constants.BONUS_TYPES.BROKER_FEES:
        return 'Broker fees'

      }

    },

    bonusPercentage () {
      return `${parseFloat(get(this, 'params.data.bonus_percentage', 0))}%`
    },

    isOff () {
      return !(this.params.data.bonus_type)
    },

    isDiscount () {
      return this.params.data.bonus_type &&
        this.params.data.bonus_type === this.$constants.BONUS_TYPES.DISCOUNT
    }


  }
}
</script>

<style lang="scss" scoped>
.status {
  line-height: 20px;
  margin-top: 4px;
}

.status-span {
  display: block;
  height: 20px;
}

.status-span-center {
  line-height: inherit;
  margin-top: 0;

  span {
    height: inherit;
  }
}

.danger {
  color: var(--danger-variant);
}

.green {
  color: var(--green);
}

</style>
